"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Navbar = _interopRequireDefault(require("./desktop/Navbar"));

var _Navbar2 = _interopRequireDefault(require("./mobile/Navbar"));

var _NavProvider = _interopRequireDefault(require("./NavProvider"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * The navigation bar for WorkL branded sites.
 *
 * This component includes both mobile & desktop navigation.
 *
 * To learn more about how to use this component, see the README for @engaging-tech/navigation.
 *
 * @param {object} props React components passed in props
 * @param {function} [props.siteLogo] The site's logo. Shown on the top left
 * @param {object[]} [props.routes] The main routes that should be visible on the navbar.
 * @param {object[]} [props.accountRoutes] The account-related routes that should be visible
 * on the navbar.
 * @param {object} [props.accountRoutesProps] Props for account routes.
 * @param {object} [props.offAxisButtonRoute] Route of button that appears below navbar.
 * @param {object[]} [props.auxillaryRoutes] Any other routes that should be visible on the navbar.
 * @param {object} [props.premiumRoute] Route for user to signup to premium account.
 * @param {object} [props.userDetails] Logged in user details.
 * @param {object} [props.elevation] Dropshadow of desktop navbar.
 * @param {object} [props.height] Height of top section of desktop navbar.
 * @param {string} [props.tabBarColor] Tab bar background colour.
 * @param {object} [props.holdingImage] Image to display when there is no profile picture available.
 * @param {string} [props.profilePath] Route for navigating user to their profile page.
 * @param {function | null} [props.ExtraNavComponent] Extra component to be rendered after Auxillary links.
 * @param {object} [props.fontFamilies] Change font family of main route navigation items.
 * @param {number} [props.mobileNavbarHeight] Change height of mobile navbar.
 * @param {number} [props.zIndex] Change z-index of whole navbar.
 * @param {object} [props.navbarItemColor] Object defining nav item font color states.
 * @param {string} [props.navbarItemColor.selected] Color of nav item font when active route.
 * @param {string} [props.navbarItemColor.unSelected] Color of nav item font when unactive route.
 * @param {object} [props.tabBarItemColor] Object defining nav item font color states.
 * @param {string} [props.tabBarItemColor.selected] Color of nav item font when active route.
 * @param {string} [props.tabBarItemColor.unSelected] Color of nav item font when unactive route.
 */
var Navbar = function Navbar(_ref) {
  var _ref$routes = _ref.routes,
      routes = _ref$routes === void 0 ? [] : _ref$routes,
      _ref$accountRoutes = _ref.accountRoutes,
      accountRoutes = _ref$accountRoutes === void 0 ? [] : _ref$accountRoutes,
      _ref$accountRoutesPro = _ref.accountRoutesProps,
      accountRoutesProps = _ref$accountRoutesPro === void 0 ? {} : _ref$accountRoutesPro,
      _ref$auxillaryRoutes = _ref.auxillaryRoutes,
      auxillaryRoutes = _ref$auxillaryRoutes === void 0 ? [] : _ref$auxillaryRoutes,
      siteLogo = _ref.siteLogo,
      linkTo = _ref.linkTo,
      offAxisButtonRoute = _ref.offAxisButtonRoute,
      premiumRoute = _ref.premiumRoute,
      userDetails = _ref.userDetails,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 150 : _ref$height,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 30 : _ref$zIndex,
      tabBarColor = _ref.tabBarColor,
      _ref$mobileNavbarHeig = _ref.mobileNavbarHeight,
      mobileNavbarHeight = _ref$mobileNavbarHeig === void 0 ? 56 : _ref$mobileNavbarHeig,
      holdingImage = _ref.holdingImage,
      _ref$tabBarItemColor = _ref.tabBarItemColor,
      tabBarItemColor = _ref$tabBarItemColor === void 0 ? {} : _ref$tabBarItemColor,
      _ref$navbarItemColor = _ref.navbarItemColor,
      navbarItemColor = _ref$navbarItemColor === void 0 ? {
    selected: "secondary.0",
    unSelected: "secondary.1"
  } : _ref$navbarItemColor,
      _ref$profilePath = _ref.profilePath,
      profilePath = _ref$profilePath === void 0 ? "/" : _ref$profilePath,
      _ref$ExtraNavComponen = _ref.ExtraNavComponent,
      ExtraNavComponent = _ref$ExtraNavComponen === void 0 ? null : _ref$ExtraNavComponen,
      _ref$fontFamilies = _ref.fontFamilies,
      fontFamilies = _ref$fontFamilies === void 0 ? {
    selected: "Centra",
    unSelected: "Centra"
  } : _ref$fontFamilies,
      headerLogo = _ref.headerLogo,
      cartData = _ref.cartData,
      cartShow = _ref.cartShow;

  var _useState = (0, _react.useState)(false),
      isDrawerOpen = _useState[0],
      setIsDrawerOpen = _useState[1];

  var toggleDrawer = function toggleDrawer() {
    return setIsDrawerOpen(!isDrawerOpen);
  };

  return /*#__PURE__*/_react["default"].createElement(_NavProvider["default"], {
    routes: routes,
    accountRoutes: accountRoutes,
    accountRoutesProps: accountRoutesProps,
    auxillaryRoutes: auxillaryRoutes,
    drawerIsOpen: isDrawerOpen,
    toggleDrawer: toggleDrawer,
    offAxisButtonRoute: offAxisButtonRoute,
    premiumRoute: premiumRoute,
    userDetails: userDetails,
    elevation: elevation,
    height: height,
    holdingImage: holdingImage,
    profilePath: profilePath,
    ExtraNavComponent: ExtraNavComponent,
    mobileNavbarHeight: mobileNavbarHeight,
    fontFamilies: fontFamilies,
    zIndex: zIndex,
    tabBarColor: tabBarColor,
    tabBarItemColor: tabBarItemColor,
    navbarItemColor: navbarItemColor,
    headerLogo: headerLogo,
    cartData: cartData,
    cartShow: cartShow
  }, /*#__PURE__*/_react["default"].createElement(_Navbar2["default"], {
    siteLogo: siteLogo,
    linkTo: linkTo
  }), /*#__PURE__*/_react["default"].createElement(_Navbar["default"], {
    siteLogo: siteLogo,
    linkTo: linkTo
  }));
};

var _default = Navbar;
exports["default"] = _default;